<div class="db-domain-offer" [ngClass]="{'single': single}">
  <div class="db-domain-offer__explore">
    <div class="db-domain-offer__globus" *ngIf="!isMobile">
      <i class="db-icon db-icon-ds-globus"></i>
    </div>
    <h1 [ngClass]="{'mt20': !isMobile}" [innerHTML]="title"></h1>
    <p class="mt10" [innerHTML]="desc"></p>
    <a class="ds-btn-purple-blue rectangle ds-btn-l mt50"
       [ngClass]="{'mt50': !isMobile, 'mt20': !!isMobile}"
       (click)="getDomain()">
      <span [innerHTML]="buttonText"></span>
    </a>
  </div>
  <div class="db-domain-offer__information" [ngClass]="{'desktop': !isMobile}"></div>
</div>
